'use client'

import { useRef, useState } from 'react'
import { Dialog, DialogPanel } from '@headlessui/react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import Tipologia from './components/Tipologia'
import ImageStrip from './components/ImageStrip'

export default function Example() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

    const targetRef = useRef(null)
    const appointment = useRef(null)

    const scrollToSection = (tgt) => {
        tgt.current?.scrollIntoView({ behavior: 'smooth' })
    }

    return (
        <div className="bg-white">
            <main>
                {/* Hero section */}
                <div className="relative isolate overflow-hidden bg-gray-900 pb-0 pt-0 sm:pb-16">
                    <img
                        alt=""
                        src="/images/esterno-2.jpeg"
                        className="absolute  w-full inset-0 -z-10 size-full object-cover"
                    />
                    <div className="absolute inset-0 bg-black/30 -z-10"></div>
                    <div
                        aria-hidden="true"
                        className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
                    >
                        <div
                            className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-20 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
                        />
                    </div>
                    <div className="mx-auto max-w-7xl px-6 lg:px-8">
                        <div className="mx-auto max-w-4xl py-32 sm:py-48 lg:py-32">
                            <div className="hidden sm:mb-8 sm:flex sm:justify-center">
                                <div className="relative rounded-full px-3 py-1 text-sm/6 text-yellow-400 ring-1 ring-yellow-400/30 hover:ring-white/20">
                                    Tecnologia e Benessere
                                </div>
                            </div>
                            <div className="text-center">
                                <h1 className="lg:mt-0 mt-40 drop-shadow-xl text-balance text-5xl font-semibold tracking-tight text-white sm:text-7xl">
                                    Vendesi nuove Residenze <span className="text-teal-200">Pensate per te</span><br/>e
                                    la <span className="text-teal-200">tua famiglia.</span>
                                </h1>
                                <p
                                    style={{ textShadow: '#000 1px 0 10px' }}
                                    className="mt-8 text-pretty text-lg font-medium text-white sm:text-xl/8"
                                >
                                    15 appartamenti, 2 Negozi, 7 Posti auto privati e 22 autorimesse singole/doppie in
                                    centro città a Bergamo.
                                </p>
                                <div className="mt-10 flex items-center justify-center gap-x-6">
                                    <button
                                        onClick={() => scrollToSection(targetRef)}
                                        className="rounded-md bg-teal-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-teal-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-400"
                                    >
                                        Scopri di Più
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="mx-auto shadow-2xl items-center gap-4 flex lg:flex-row flex-col justify-center max-w-lg bg-black rounded-xl py-4">
                            <img
                                alt="ItalHome"
                                width={218}
                                height={48}
                                src="/images/brand_0.png"
                                className=""
                            />
                            <img
                                alt="EcoCostruzioni"
                                src="/images/brand_2.png"
                                width={78}
                                height={48}
                                className=""
                            />
                            <img
                                alt="Atmostera"
                                src="/images/brand_1new.png"
                                width={158}
                                height={48}
                                className=""
                            />
                        </div>
                    </div>
                    <div
                        aria-hidden="true"
                        className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]"
                    >
                        <div
                            style={{
                                clipPath:
                                    'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                            }}
                            className="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-20 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]"
                        />
                    </div>
                </div>

                {/* Feature section */}
                <div
                    className="mt-32 sm:mt-56"
                    ref={targetRef}
                >
                    <div className="mx-auto max-w-7xl px-6 lg:px-8">
                        <div className="mx-auto max-w-2xl text-left">
                            <h2 className="text-base/7 font-semibold text-teal-600">Tutto ciò di cui hai bisogno</h2>
                            <p className="mt-2 text-pretty text-4xl font-semibold tracking-tight text-gray-900 sm:text-balance sm:text-5xl">
                                Tecnologia e Benessere

                            </p>
                            <p className="mt-6 text-lg text-gray-600">
                                Alle spalle di Piazza S. Anna, traversa dell'antica Borgo Palazzo, è nato un Nuovo
                                intervento residenziale di 15 appartamenti, 2 Negozi, 7 Posti auto privati e 22
                                autorimesse singole/doppie.
                            </p>
                            <p className="mt-6 text-lg text-gray-600">
                                La nuova "RESIDENZA VIA PIATTI 12" è in corso di costruzione, i lavori stanno avanzando
                                con consegna prevista per fine Anno (2025).
                            </p>
                            <p className="mt-6 text-lg text-gray-600">
                                L'intervento si contraddistingue grazie alle sue <strong>meravigliose terrazze</strong>,
                                vivibili e molto spaziose, alcune anche attrezzate, ed alle sue <strong>finiture
                                moderne</strong>, con design innovativo e di qualità.
                            </p>
                            <p className="mt-6 text-lg text-gray-600">
                                L'ultimo piano, raggiungibile con <strong>ascensore privato</strong>, è composto da n.2
                                meravigliosi Attici introvabili, con terrazze magnifiche e stellari.

                                <strong>Materiali di pregio, ampia scelta di capitolato.</strong>

                                Tecnologie all'avanguardia che consentono di ottenere un elevato comfort abitativo ed un
                                bassissimo consumo energetico.
                            </p>
                            <p className="mt-6 text-lg text-gray-600">
                                Classe energetica A4.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="mt-12">
                    <video
                        src="/open-house.mp4"
                        muted
                        autoPlay
                    ></video>
                </div>

                {/* Testimonial section */}
                <div className="relative z-10 mt-32 bg-gray-900 pb-20 sm:mt-56 sm:pb-24 xl:pb-0">
                    <div
                        aria-hidden="true"
                        className="absolute inset-0 overflow-hidden"
                    >
                        <div className="absolute left-[calc(50%-19rem)] top-[calc(50%-36rem)] transform-gpu blur-3xl">
                            <div
                                style={{
                                    clipPath:
                                        'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                                }}
                                className="aspect-[1097/1023] w-[68.5625rem] bg-gradient-to-r from-[yellow] to-[green] opacity-25"
                            />
                        </div>
                    </div>
                    <div className="mx-auto flex max-w-7xl flex-col items-center gap-x-8 gap-y-10 px-6 sm:gap-y-8 lg:px-8 xl:flex-row xl:items-stretch">
                        <div className="-mt-8 w-full max-w-2xl xl:-mb-8 xl:w-96 xl:flex-none">
                            <div className="relative aspect-[2/1] h-full md:-mx-8 xl:mx-0 xl:aspect-auto">
                                <img
                                    alt=""
                                    src="/images/esterno-3.jpeg"
                                    className="absolute inset-0 size-full rounded-2xl bg-gray-800 object-cover shadow-2xl"
                                />
                            </div>
                        </div>
                        <div className="w-full max-w-2xl xl:max-w-none xl:flex-auto xl:px-16 xl:py-24">
                            <figure className="relative isolate pt-6 sm:pt-12">
                                <svg
                                    fill="none"
                                    viewBox="0 0 162 128"
                                    aria-hidden="true"
                                    className="absolute left-0 top-0 -z-10 h-32 stroke-white/20"
                                >
                                    <path
                                        d="M65.5697 118.507L65.8918 118.89C68.9503 116.314 71.367 113.253 73.1386 109.71C74.9162 106.155 75.8027 102.28 75.8027 98.0919C75.8027 94.237 75.16 90.6155 73.8708 87.2314C72.5851 83.8565 70.8137 80.9533 68.553 78.5292C66.4529 76.1079 63.9476 74.2482 61.0407 72.9536C58.2795 71.4949 55.276 70.767 52.0386 70.767C48.9935 70.767 46.4686 71.1668 44.4872 71.9924L44.4799 71.9955L44.4726 71.9988C42.7101 72.7999 41.1035 73.6831 39.6544 74.6492C38.2407 75.5916 36.8279 76.455 35.4159 77.2394L35.4047 77.2457L35.3938 77.2525C34.2318 77.9787 32.6713 78.3634 30.6736 78.3634C29.0405 78.3634 27.5131 77.2868 26.1274 74.8257C24.7483 72.2185 24.0519 69.2166 24.0519 65.8071C24.0519 60.0311 25.3782 54.4081 28.0373 48.9335C30.703 43.4454 34.3114 38.345 38.8667 33.6325C43.5812 28.761 49.0045 24.5159 55.1389 20.8979C60.1667 18.0071 65.4966 15.6179 71.1291 13.7305C73.8626 12.8145 75.8027 10.2968 75.8027 7.38572C75.8027 3.6497 72.6341 0.62247 68.8814 1.1527C61.1635 2.2432 53.7398 4.41426 46.6119 7.66522C37.5369 11.6459 29.5729 17.0612 22.7236 23.9105C16.0322 30.6019 10.618 38.4859 6.47981 47.558L6.47976 47.558L6.47682 47.5647C2.4901 56.6544 0.5 66.6148 0.5 77.4391C0.5 84.2996 1.61702 90.7679 3.85425 96.8404L3.8558 96.8445C6.08991 102.749 9.12394 108.02 12.959 112.654L12.959 112.654L12.9646 112.661C16.8027 117.138 21.2829 120.739 26.4034 123.459L26.4033 123.459L26.4144 123.465C31.5505 126.033 37.0873 127.316 43.0178 127.316C47.5035 127.316 51.6783 126.595 55.5376 125.148L55.5376 125.148L55.5477 125.144C59.5516 123.542 63.0052 121.456 65.9019 118.881L65.5697 118.507Z"
                                        id="b56e9dab-6ccb-4d32-ad02-6b4bb5d9bbeb"
                                    />
                                    <use
                                        x={86}
                                        href="#b56e9dab-6ccb-4d32-ad02-6b4bb5d9bbeb"
                                    />
                                </svg>
                                <blockquote className="text-xl/8 font-semibold lg:bg-transparent lg:p-0 p-4 bg-gray-900/80 text-white sm:text-2xl/9">
                                    <p>
                                        Scopri nuove residenze moderne nel cuore di Bergamo, a pochi passi da Piazza S.
                                        Anna. Un’opportunità unica per vivere in un ambiente elegante e confortevole,
                                        con ampie terrazze, materiali di pregio e tecnologie all’avanguardia per il
                                        massimo risparmio energetico.
                                    </p>
                                </blockquote>
                            </figure>
                        </div>
                    </div>
                </div>

                <ImageStrip/>

                {/* Pricing section */}
                <div className="relative isolate mt-32 bg-white px-6 sm:mt-56 lg:px-8">
                    <div
                        aria-hidden="true"
                        className="absolute inset-x-0 -top-3 -z-10 transform-gpu overflow-hidden px-36 blur-3xl"
                    >
                        <div
                            style={{
                                clipPath:
                                    'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                            }}
                            className="mx-auto aspect-[1155/678] w-[72.1875rem] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30"
                        />
                    </div>
                    <div className="mx-auto max-w-2xl sm:text-center">
                        <h2 className="text-base/7 font-semibold text-teal-600">Tipologie</h2>
                        <p className="mt-2 text-pretty text-4xl font-semibold tracking-tight text-gray-900 sm:text-balance sm:text-5xl">
                            Gli appartamenti
                        </p>
                        <p className="mt-6 text-lg/8 text-gray-600">
                            Ecco l'elenco degli appartamenti che verranno realizzati nella nuova Residenza di Via
                            Piatti.
                        </p>
                    </div>
                    <Tipologia
                        titolo="Bilocali"
                        folder="bilocali"
                        text="Grande ed Ampio appartamento Bilocale, di ca 55 mq, oltre a 15 mq di terrazza privata. Composto da: ingresso, grande cucina, spazioso soggiorno, disimpegno notte, con area lavatrice/asciugatrice, ampio bagno finestrato e camera da letto matrimoniale, oltre a meravigliosa ampia terrazza, prospicente l'immobile."
                        data={{ mq: 54.45, locali: 2, bagni: 1, balconi: 1, balconi_mq: 15.22, price: '185\'500' }}
                        appointment={appointment}
                    />
                    <Tipologia
                        titolo="Trilocali"
                        folder="trilocali"
                        text="Grande ed Ampio appartamento Trilocale, di ca 72 mq, oltre a 15 mq di terrazza privata. Composto da: ingresso, spazioso soggiorno con angolo cottura, disimpegno notte, 2 camere da letto, di cui una (la matrimoniale) con bagno en suite privato, ulteriore secondo bagno, oltre a meravigliosa terrazza con vista panoramica."
                        data={{ mq: '71.95', locali: 3, bagni: 2, balconi: 1, balconi_mq: 15.22, price: '251\'500' }}
                        appointment={appointment}
                    />
                    <Tipologia
                        titolo="Quadrilocali"
                        text="Grande Quadrilocale, di ca 119 mq, oltre a 19 mq di terrazza privata. Composto da: ingresso, grande cucina abitabile, spazioso soggiorno, disimpegno notte, con area lavatrice/asciugatrice, doppi servizi, 3 camere da letto, oltre a meravigliosa ampia terrazza, prospicente tutta la zona giorno."
                        folder="quadrilocali"
                        data={{ mq: '118.70', locali: 4, bagni: 2, balconi: 1, balconi_mq: 18.84, price: '388\'000' }}
                        appointment={appointment}
                    />
                    <Tipologia
                        titolo="Attici"
                        preText={'Appartamenti'}
                        text="Attico di ca 230 mq, oltre a ca 90 mq di introvabili terrazze attrezzate, stellari/solarium con possibilità piscina, e meravigliosa vista su tutta la Città, Città Alta, Colli - Baciate dal sole!
L'attico si dispone su 2 piani con ascensore privato ed è composto da: Ingresso, Grande Salone, sala da pranzo, cucina abitabile, con isola, camera matrimoniale/suite con cabina armadio, zona lettura + bagno privato con jacuzzi e doppio lavello, 3 camere da letto con altri 2 bagni ed altre 2 cabine armadio uomo-donna-bambini, con spazio lavatrice ed asciugatrice, oltre a 3 meravigliose terrazze attrezzate, stellari/solarium con possibilità piscina, e meravigliosa vista su tutta la Città, Città Alta, Colli - Baciate dal sole!
Possibilità di realizzare la 5° camera da letto!
Infine, l'ultimo piano è caratterizzato da meravigliose travi a vista in legno, che accolgono e riscaldano il reparto notte."
                        folder="attici"
                        data={{ mq: '131.48', locali: 5, bagni: 3, balconi: 3, price: null }}
                        appointment={appointment}
                    />
                    <Tipologia
                        titolo="Negozio"
                        preText={'Servizi'}
                        text="Grande spazio commerciale, disposto tutto su unico livello (Piano Terra) con 4 grandi vetrine, doppio ingresso, oltre 4 grandi vetrate, 10 vani, divisibili, personalizzabili, su richiesta del cliente, possibilità di realizzare 3 bagni, oltre ad uno spazio esterno, piazza-cortile-dehor privato, in parte coperto, ( unico in tutta la città di Bergamo) - INTROVABILE di circa 200 mq, e possibilità di avere un accesso autonomo!"
                        folder="negozi"
                        data={{ mq: '167.02', price: null }}
                        appointment={appointment}
                    />
                </div>
                <div
                    className="mb-16"
                    ref={appointment}
                >
                    <div className="relative isolate overflow-hidden bg-gray-900">
                        <div className="px-6 py-24 sm:px-6 sm:py-32 lg:px-8">
                            <div className="mx-auto max-w-2xl text-center">
                                <h2 className="text-balance text-4xl font-semibold tracking-tight text-white sm:text-5xl">
                                    Prenota una visita
                                </h2>
                                <p className="mx-auto mt-6 max-w-xl text-pretty text-lg/8 text-gray-300">
                                    Per appuntamenti:<br/>MARTEDI e GIOVEDI dalle 10:00 alle 15:00<br/>SABATO dalle
                                    10:00
                                    alle 16:00<br/>Previa prenotazione chiamando il n. 035.21.08.97
                                </p>
                                <div className="mt-10 flex items-center justify-center gap-x-6">
                                    <a
                                        href="tel:+39035210897"
                                        className="rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                                    >
                                        Chiama Ora
                                    </a>
                                </div>
                            </div>
                        </div>
                        <svg
                            viewBox="0 0 1024 1024"
                            aria-hidden="true"
                            className="absolute left-1/2 top-1/2 -z-10 size-[64rem] -translate-x-1/2 [mask-image:radial-gradient(closest-side,white,transparent)]"
                        >
                            <circle
                                r={512}
                                cx={512}
                                cy={512}
                                fill="url(#8d958450-c69f-4251-94bc-4e091a323369)"
                                fillOpacity="0.7"
                            />
                            <defs>
                                <radialGradient id="8d958450-c69f-4251-94bc-4e091a323369">
                                    <stop stopColor="yellow"/>
                                    <stop
                                        offset={1}
                                        stopColor="yellow"
                                    />
                                </radialGradient>
                            </defs>
                        </svg>
                    </div>
                </div>
            </main>


            {/* Footer */}
            <footer className="bg-gray-900">
                <div className="mx-auto max-w-7xl overflow-hidden px-6 py-20 sm:py-24 lg:px-8">
                    <div className="flex justify-center gap-x-10 text-gray-400">
                        Il presente materiale ha scopo illustrativo e non costituisce vincolo contrattuale
                    </div>
                    <p className="mt-10 text-center text-sm/6 text-gray-400">&copy; 2025 Ital Home. Tutti i diritti
                        riservati.</p>
                </div>
            </footer>
        </div>
    )
}
